import { c as _c } from "react/compiler-runtime";
import { textColorVariants } from "../../styles";
import { classNames } from "../../utils";
import { Slot } from "../Slot";
/**
 * A `Slot` that displays a `div` by default.
 * Also includes text color variants.
 */
export function Block(t0) {
  const $ = _c(12);
  let asChild;
  let className;
  let color;
  let rest;
  if ($[0] !== t0) {
    ({
      asChild,
      color,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = asChild;
    $[2] = className;
    $[3] = color;
    $[4] = rest;
  } else {
    asChild = $[1];
    className = $[2];
    color = $[3];
    rest = $[4];
  }
  const Comp = asChild ? Slot : "div";
  let t1;
  if ($[5] !== className || $[6] !== color) {
    t1 = classNames(textColorVariants({
      color
    }), className);
    $[5] = className;
    $[6] = color;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== Comp || $[9] !== rest || $[10] !== t1) {
    t2 = <Comp className={t1} {...rest} />;
    $[8] = Comp;
    $[9] = rest;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}